import { defineStore } from 'pinia';
import { reactive, ref, watch } from 'vue';
import { GetAnnouncements } from '@/services/Announcements/GetAnnouncements';
import { GetCompanyLookups } from '../services/Lookups/GetCompanyLookups';
import { GetRecipientLookups } from '../services/Lookups/GetRecipientLookups';

export const useAnnouncementStore = defineStore('announcement', () => {
  const list = ref([]);
  const pagination = reactive({
    currentPage: 0,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 0,
  });
  const loading = ref(false);
  const filterBy = ref();
  const searchString = ref();
  const announcementTab = ref('announcementAll');
  const announcementTabCounter = ref({
    draft: 0,
    all: 0,
  });
  const selectForm = ref({
    companies: [],
    employeeTypes: [],
  });
  const editModalData = ref();
  const isFromEdit = ref(false);
  const isFormEditState = ref(false);
  const successToast = ref(false);
  const successToastLocal = ref(false);
  const isSuccessDraft = ref(false);
  const successToastMessage = ref('');
  watch(loading, (newLoader) => {
    if (successToast.value && !newLoader) {
      successToastLocal.value = successToast.value;
    }
  });

  const getAnnouncements = (payload) => {
    loading.value = true;
    GetAnnouncements(
      payload?.isDraft,
      payload?.searchString,
      payload?.filterBy,
      payload?.pageNumber,
      payload?.rowsPerPage
    ).then((response) => {
      if (payload?.isCounterOnly) {
        announcementTabCounter.value.draft = response.pagination.totalItems;
      } else {
        list.value = response.data;
        pagination.currentPage = response.pagination.currentPage;
        pagination.totalPages = response.pagination.totalPages;
        pagination.totalItems = response.pagination.totalItems;
        pagination.itemsPerPage = response.pagination.itemsPerPage;
        if (announcementTab.value == 'announcementAll') {
          announcementTabCounter.value.all = pagination.totalItems;
        }
        loading.value = false;
      }
    });
  };

  const getListToArray = (sentList) => {
    return sentList.split(',');
  };

  const changePage = (newCurrentPage, newRowsPerPage) => {
    let pageParams = {
      pageNumber: newCurrentPage,
      rowsPerPage: newRowsPerPage,
    };

    const checkBlankSpace = /^ *$/;
    if (
      searchString.value &&
      !checkBlankSpace.test(searchString.value) &&
      filterBy.value[0] != ''
    ) {
      pageParams = {
        ...pageParams,
        filterBy: filterBy.value,
        searchString: searchString.value,
      };
    }

    if (announcementTab.value == 'announcementDrafts') {
      pageParams = {
        ...pageParams,
        isDraft: true,
      };
    }
    getAnnouncements(pageParams);
  };

  const changeCurrentPage = (newCurrentPage) => {
    changePage(newCurrentPage, pagination.itemsPerPage);
  };

  const changeItemPerPage = (newItemPerPage) => {
    changePage(1, newItemPerPage);
  };

  const isFeatureFlagOn = ref(false);
  const companyList = ref([]);
  const totalCompanies = ref();
  const recipientList = ref([]);
  const getCompanyList = () => {
    GetCompanyLookups().then((response) => {
      companyList.value = response.data;
      totalCompanies.value = response.pagination.totalItems;
    });
  };
  const getRecipientList = () => {
    GetRecipientLookups().then((response) => {
      recipientList.value = response.data;
    });
  };

  return {
    list,
    pagination,
    loading,
    filterBy,
    searchString,
    announcementTab,
    getListToArray,
    changeCurrentPage,
    changeItemPerPage,
    getAnnouncements,
    announcementTabCounter,
    selectForm,
    editModalData,
    isFromEdit,
    isFormEditState,
    isFeatureFlagOn,
    getCompanyList,
    companyList,
    getRecipientList,
    recipientList,
    totalCompanies,
    successToast,
    isSuccessDraft,
    successToastMessage,
    successToastLocal,
  };
});
